import { ConfirmationData } from "../../../../common/summary-common/confirmationData";

export const overWriteSubstanceConsumptionInformation: Map<string, ConfirmationData> = new Map([
    ["8935800d-f830-4101-b5cb-bf6c3977dd13", { hidden: true }],
    ["c418803a-fe66-4fd1-9c61-a845bbe9e4bc|0d8fcccc-a79e-4c64-a0f4-9d34da120e27", { label: "Sí/No" }],
    ["de7163fa-c6c7-44bf-b660-6d9018211b58|8b3a5d82-eb5e-4cfc-8133-f23491642a69", { fontWeight: "bold" }],
    ["d70eb4d8-c5e7-4c59-a4bd-d32bae8f4805|158d16a0-1de7-4815-a29d-fe2453c0e484", { label: "Sí/No" }],
    ["2fc547b0-f279-4727-bed1-a8dbd5a33f69", { hidden: true }],
    
]); 